import { TrashIcon } from "../../../../components/buttons/IconButtons"

/**
 * @Author      Jhovanny Fragoso Marquez
 * @JobTitle    Frontend Developer
 * @Email       jfragoso@ibl.mx
 *
 * @component
 * @name UnselectedCard
 * @description Visual component that displays a trash icon. When clicking on the container, it triggers the provided `onClick` function.
 *
 * @param {Object} props - Component props.
 * @param {Function} [props.onClick=() => {}] - Function to execute when the component is clicked.
 *
 * @returns {JSX.Element} A container with a trash icon.
 */

const UnselectedCard = ({ onClick = () => { } }) => {
    return (
        <div className="unchecked-card-container w-120px-h-120px d-flex justify-content-center align-items-center background-general-950 rounded-circle" onClick={onClick}>
            <TrashIcon className="trash-icon-card w-72px-h-72px icon-color-general-00" />
        </div>
    )
}

export default UnselectedCard 